
namespace Matrix.Indexation {
    export class FactCompositeConstituentColumns {
        static columnsKey = 'Indexation.FactCompositeConstituent';
    }
}